/**
 * @file TitleComponent.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente del título de la página
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-01-15
 * @modified 2025-09-09
 * @author DLTCode
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Link } from "@/features/i18n";
import { TitleComponentProps } from "@/types/ui";
import ReturnButton from "./ReturnButton";
import clsx from "clsx";
import { useLastLogInDate } from "@/features/auth";
import MyBreadcrumbs from "./BreadCrumbs";
import { useTranslations } from "next-intl";
const TitleComponent = t0 => {
  const $ = _c(28);
  let backButtonHref;
  let className;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      backButtonHref,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backButtonHref;
    $[2] = className;
    $[3] = props;
    $[4] = title;
  } else {
    backButtonHref = $[1];
    className = $[2];
    props = $[3];
    title = $[4];
  }
  const lastLogInDate = useLastLogInDate();
  const t = useTranslations("Title");
  let t1;
  if ($[5] !== className) {
    t1 = clsx("title", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== backButtonHref) {
    t2 = backButtonHref && <ReturnButton href={backButtonHref} />;
    $[7] = backButtonHref;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MyBreadcrumbs />;
    t4 = {
      pointerEvents: "auto"
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== title) {
    t5 = typeof title === "string" ? title : <>{title.map((route, index) => {
        const isLast = index === title.length - 1;
        return <React.Fragment key={index}>{!("href" in route) ? <span aria-current={isLast ? "page" : undefined}>{route.name}</span> : <Link href={route.href} style={{
            fontWeight: "normal",
            color: "hsla(0, 0%, 53%, 1)"
          }}>{route.name}</Link>}{!isLast && <span aria-hidden="true"> / </span>}</React.Fragment>;
      })}</>;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <section className="title__content__flex--title">{t3}<h1 style={t4}>{t5}</h1></section>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t6) {
    t7 = <section className="title__content__flex">{t2}{t6}</section>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== lastLogInDate || $[19] !== t) {
    t8 = lastLogInDate && <section style={{
      flexShrink: 0,
      display: "flex",
      gap: "0.5rem"
    }}><p style={{
        fontSize: "12px",
        fontWeight: "800",
        lineHeight: "14px",
        letterSpacing: 0.4,
        color: "var(--gray)",
        fontFamily: "Inter"
      }}>{t("lastSession")}</p><p style={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "14px",
        color: "var(--gray)",
        fontFamily: "Inter"
      }}>{lastLogInDate}</p></section>;
    $[18] = lastLogInDate;
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <section className="title__content">{t7}{t8}</section>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== props || $[25] !== t1 || $[26] !== t9) {
    t10 = <header className={t1} {...props}>{t9}</header>;
    $[24] = props;
    $[25] = t1;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default TitleComponent;